import React from 'react';
import * as S from './Loader.styles';
import { LoaderSize } from './Loader.styles';

interface LoaderProps {
  size?: LoaderSize;
}
const Loader: React.FC<LoaderProps> = ({ size = 'large' }) => {
  return (
    <S.Div $size={size}>
      {/* {isMaintenanceMode && (
        <>
          <Poppins>Site under maintenance</Poppins>
          <Spacer $px={20} />
        </>
      )} */}
      <div className="loader" />
    </S.Div>
  );
};

export default Loader;
